export default __webpack_public_path__ + "0b71fbdb561eaec4af6830de97367db4.svg";